import { toQueryString, toRelativeUrl } from './uri';

export function buildCampaignUrl(campaignIdentifier, filterTag) {
    if (filterTag) {

        return `/campaigns/${campaignIdentifier}/${filterTag}`;
    }

    return `/campaigns/${campaignIdentifier}`;
}

/**
 * Builds a direct URL for a given campaign and a set of categories.
 * @param {string} campaignIdentifier
 * @param {string[]} categoryIds
 * @param {object} filter Filter query for colors and prices.
 * @param {string} key Secret campaign key.
 */
export function buildCategoryUrl(campaignIdentifier, categoryIds, filter = null, key = null) {
    if (key) {
        filter = { ...filter, key };
    }

    // it's ok to have a null filter here
    const query = toQueryString(filter);

    return toRelativeUrl(
        `/campaigns/${campaignIdentifier}/categories/${categoryIds.join(',')}`,
        query
    );
}
